export default "__VITE_PUBLIC_ASSET__da8229df__"